export default "__VITE_ASSET__BT6uQsiM__"